import React from "react";
import Label from "../../../../../mxGraph/HCLTreeNode/HCLTreeVertexValue/Label";
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import InputRules from "./InputRules";
import GridItemInput from "./GridItemInput";

interface Props extends GridItemInput {
  label: Label;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>, name: string, multiple?: boolean) => void;
  name: string;
  onError: (error: boolean) => void;
}

class LabelInput extends React.Component<Props> {

  private handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { onChange, name } = this.props;
    onChange(e, name);
  };

  private handleNameChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { onChange, name, onError } = this.props;
    onError(InputRules.isEmpty(e.target.value));
    onChange(e, name);
  };

  render() {
    const { label, gridItemProps } = this.props;

    const isNameValid = !InputRules.isEmpty(label.getName());

    return (
      <React.Fragment>
        <Grid {...gridItemProps} item>
          <TextField
            required
            label="Name"
            name="name"
            value={label.getName()}
            error={!isNameValid}
            onChange={this.handleNameChange}
            helperText={isNameValid ? undefined : InputRules.DESCRIPTIONS.EMPTY}
            margin="normal"
            type="text"
            variant="outlined"
            fullWidth
          />
        </Grid>
        <Grid {...gridItemProps} item>
          <TextField
            label="Description"
            name="description"
            multiline
            variant="outlined"
            value={label.getDescription()}
            onChange={this.handleChange}
            margin="normal"
            type="text"
            fullWidth
          />
        </Grid>
      </React.Fragment>
    )
  }
}

export default LabelInput;
